// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"334":"80b92875","916":"2a2959cc"}[chunkId] + ".js";
};